import React from 'react';
import { motion } from 'framer-motion';
import { useData } from '../context/DataContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiShoppingCart } = FiIcons;

const ProductCard = ({ product }) => {
  const { addToCart } = useData();

  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow border border-gray-100"
    >
      <div className="relative aspect-square">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        {product.featured && (
          <div className="absolute top-3 left-3 bg-blue-600 text-white px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider">
            Featured
          </div>
        )}
        {product.stock < 10 && product.stock > 0 && (
          <div className="absolute top-3 right-3 bg-amber-500 text-white px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider">
            Low Stock
          </div>
        )}
        {product.stock === 0 && (
          <div className="absolute inset-0 bg-white/80 backdrop-blur-[2px] flex items-center justify-center">
            <span className="bg-gray-900 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase">Out of Stock</span>
          </div>
        )}
      </div>
      
      <div className="p-5">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded uppercase tracking-wide">
            {product.category}
          </span>
          <div className="flex items-center">
            <SafeIcon icon={FiStar} className="h-3.5 w-3.5 text-yellow-400 fill-current" />
            <span className="text-xs font-semibold text-gray-600 ml-1">4.8</span>
          </div>
        </div>
        
        <h3 className="text-base font-bold text-gray-900 mb-1 line-clamp-1">
          {product.name}
        </h3>
        
        <p className="text-gray-500 text-xs mb-4 line-clamp-2 min-h-[2rem]">
          {product.description}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-xl font-black text-gray-900">
              ${product.price.toFixed(2)}
            </span>
            <span className="text-[10px] text-gray-400 font-medium">
              {product.stock} units left
            </span>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            disabled={product.stock === 0}
            onClick={() => addToCart(product)}
            className={`flex items-center px-4 py-2.5 rounded-xl font-bold text-sm transition-all ${
              product.stock === 0
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg shadow-blue-100'
            }`}
          >
            <SafeIcon icon={FiShoppingCart} className="h-4 w-4 mr-2" />
            Add
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;